// extracted by mini-css-extract-plugin
export default {"past":"index_past_nt7ZI","pastH":"index_pastH_RDtoV","passItem":"index_passItem_AvZGO"};